module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jana Klauer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Jana Klauer, M.D., is the national director of nutrition at Equinox in New York City. She is also a research fellow at the New York Obesity Research Center of St. Luke's-Roosevelt Hospital and is actively involved in clinical research on obesity. She is in private practice in New York City, where she lives.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BHcvsU/tc-custom/9781429906203.jpg?1731166618844",
      "alt": "This image is the cover for the book How the Rich Get Thin"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How the Rich Get Thin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("You know the ones: the women walking down Park or Fifth Avenues on Manhattan's Upper East Side. Hermes handbag on the arm. Hair just so.  Sleek and groomed as greyhounds. "), _c('i', [_vm._v("How The Rich Get Thin")]), _vm._v(", from one of New York's premier weight control doctors, reveals the secrets of how the successful and rich get and stay thin.  With a quick-start two week program that the dieter later builds on to keep losing weight and eventually to maintain their shape, "), _c('i', [_vm._v("How The Rich Get Thin ")]), _vm._v("includes:"), _c('br'), _c('br'), _vm._v("--Meal plans high in protein, omega-3 fats and complex carbohydrates"), _c('br'), _vm._v("--Calcium, through food rather than supplements, in the maximum amount the body can absorb at a time"), _c('br'), _vm._v("--A morning exercise program as an adjunct to eating"), _c('br'), _vm._v("--The Stop Watch method to curb food cravings: any craving can be stopped within just 15 minutes"), _c('br'), _vm._v("--How to eat at fabulous restaurants, for business or pleasure, and keep losing weight.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Griffin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0